import { render, staticRenderFns } from "./Guides.vue?vue&type=template&id=534a4a29&lang=pug"
import script from "./Guides.vue?vue&type=script&lang=js"
export * from "./Guides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports